import { render } from "./FinancialTipsCarousel.vue?vue&type=template&id=51dd8378&scoped=true&ts=true"
import script from "./FinancialTipsCarousel.vue?vue&type=script&lang=ts"
export * from "./FinancialTipsCarousel.vue?vue&type=script&lang=ts"

import "./FinancialTipsCarousel.vue?vue&type=style&index=0&id=51dd8378&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd8378"]])

export default __exports__